import { useState, useCallback } from 'react';

/**
 * useState that persists to localStorage as JSON.
 *
 * @param {string} key           localStorage key
 * @param {*}      defaultValue  fallback if nothing in storage (or a function returning it)
 * @returns {[*, function]}
 */
export function useLocalStorage(key, defaultValue) {
  const [value, _setValue] = useState(() => {
    try {
      const saved = localStorage.getItem(key);
      if (saved !== null) return JSON.parse(saved);
    } catch {}
    return typeof defaultValue === 'function' ? defaultValue() : defaultValue;
  });

  const setValue = useCallback((valOrFn) => {
    _setValue(prev => {
      const next = typeof valOrFn === 'function' ? valOrFn(prev) : valOrFn;
      try { localStorage.setItem(key, JSON.stringify(next)); } catch {}
      return next;
    });
  }, [key]);

  return [value, setValue];
}
